export default {
    list: {
        title: "Trung tâm thông báo",
        desc: "Xem các cập nhật mới nhất, sự kiện vận hành, cập nhật tính năng và thông báo đổi thưởng từ JX3BOX.",
        searchPlaceholder: "Tìm kiếm theo từ khóa",
        sticky: "Ghim",
        empty: "Danh mục này chưa có thông báo.",
        jump: "Đi",
        authorDefault: "JX3BOX",
        tabs: {
            all: "Tất cả",
            notice: "Thông báo",
            information: "Sự kiện",
            feature: "Cập nhật",
            message: "Đổi thưởng",
        },
    },
    single: {
        back: "Quay lại danh sách",
        lastUpdated: "Cập nhật lần cuối: {date}",
        views: "{count} lượt xem",
        edit: "Sửa",
        manage: "Quản lý",
        like: "Thích ({count})",
        star: "Yêu thích",
        starred: "Đã yêu thích",
        comments: "Bình luận",
        commentsClosed: "Thông báo này chưa bật bình luận.",
        visibilityTip: "Hiển thị: {visibility}",
        visibility: {
            public: "Công khai",
            self: "Chỉ mình tôi",
            friends: "Chỉ bạn bè",
            password: "Có mật khẩu",
            paid: "Trả phí",
            fans: "Chỉ người theo dõi",
        },
    },
};
